import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { RestService } from "../rest.service";
import { catchError, retry } from "rxjs/operators";

// Importing CountryList from Internal folder
import countryLists from "../../assets/countryList/country.json";
import stateLists from "../../assets/countryList/state.json";
import cityLists from "../../assets/countryList/city.json";
import timezoneArrayList from "../../assets/testtimeZone.json";
import { Subject } from "rxjs";

@Component({
  selector: "app-enterprise-management",
  templateUrl: "./enterprise-management.component.html",
  styleUrls: ["./enterprise-management.component.css"],
})
export class EnterpriseManagementComponent implements OnInit {
  subscriptionDetails: any;
  isDeleteModelShown: boolean = false;
  isSuspendModelShown: boolean = false;
  isRevokeModelShown: boolean = false;
  isPaymentModelShown: boolean = false;
  isEditSubModelShown: boolean = false;
  isSubscriptionEmpty: boolean = false;
  isAddedNewSubscribe: boolean = false;
  isReducedNewSubscribe: boolean = false;
  isCompanyEditBtnClicked: boolean = false;
  isTransferModelShown: boolean = false;
  isRolechecked: boolean = false;
  isTransferSucceed: boolean = false;
  isTransactionError: boolean = false;
  isErrorUpdateCreditCardDetails: boolean = false;
  UpdateCreditCardDetailsMsg: any = "";
  isTransactionSuccess: boolean = true;
  transactionSuccessMessage: any = "";
  isPaymentFailed: boolean = false;
  paymentFailedMessage: any = "";
  isPaymentSuccess: boolean = false;
  paymentFailedSuccess: any = "";
  transactionDetails: any = "";
  getIntegration: any = "";
  isSuperUser: any = "";
  url: any = "";
  basedn: any = "";
  adusername: any = "";
  adpassword: any = "";
  oktaorgurl: any = "";
  oktatoken: any = "";
  crurl: any = "";
  crusername: any = "";
  crpassword: any = "";

  isSuccess: boolean = false;
  isFailure: boolean = false;
  successMessage: any = "";
  failureMessage: any = "";

  month: any = "";
  year: any = "";
  cardnumber: any = "";
  expireDate: any = "";
  cvv: any = "XXX";

  isCardnumberEmpty: boolean = false;
  isExpireDateEmpty: boolean = false;
  iscvvEmpty: boolean = false;
  isFilled: boolean = false;

  isEditClicked: boolean = false;
  totalSubscription: any = "";
  price: any = "";
  additionSubscribe: any = 0;
  actualSubcriberCount: any;
  proratedfee: any = 0;
  totalAmount: any = 0;
  updatedSuccessMsg: any = "";
  userEmailAddress: any = "";
  convertRole: any = "";
  username: any = "";
  userPhoneNumber: any = "";
  userAlterPhoneNumber: any = "";
  firstname: any = "";
  lastname: any = "";
  userrole: any = "";
  password: any = "";
  roleId: any = "0";
  userid: any = "";
  error: string;

  cityList: [];
  stateList: [];
  userList: [];
  roleList: [];

  companyDetails: any;
  companyname: any = "";
  countryname: any = "";
  statename: any = "";
  cityname: any = "";
  countryid: any = "";
  stateid: any = "";
  cityid: any = "";
  streetaddress: any = "";
  country: any = "";
  countries: any = "";
  city: any = "";
  cities: any = "";
  state: any = "";
  states: any = "";
  zipcode: any = "";
  timezone: any = "";
  timezonename: any = "";

  superAdminDetails: any;
  adminFirstname: any = "";
  adminLastname: any = "";
  phone: any = "";
  email: any = "";
  altphone: any = "";
  suspendId: any = "";
  switch: any = "0";

  isCompanynameEmpty: boolean = false;
  isStreetaddressEmpty: boolean = false;
  isCountrynameEmpty: boolean = false;
  isStatenameEmpty: boolean = false;
  isCitynameEmpty: boolean = false;
  isZipcodeEmpty: boolean = false;
  istimezonenameEmpty: boolean = false;
  isUserEmailAddressEmpty: boolean = false;
  integrationsSave: boolean = false;
  integrationsEdit: boolean = true;

  isUserEmailAddress: boolean = false;
  isUserPhoneNumber: boolean = false;
  isUserrole: boolean = false;
  isPassword: boolean = false;
  isUrlEmpty: boolean = false;
  isBasednEmpty: boolean = false;
  isUsernameEmpty: boolean = false;
  isPasswordEmpty: boolean = false;
  isOktaorgurlEmpty: boolean = false;
  isOktatokenEmpty: boolean = false;
  isADUser: boolean = true;
  isLoading: boolean = false;
  isAdminPassword: boolean = false;
  isAPIKeySelected: boolean = true;
  isPasswordSelected: boolean = false;
  isEditEnvironmentShown: boolean = false;
  environmentList: any = [];

  environmentId: any = "";
  masterEnvironmentId: string = "";
  environmentName: any = "";
  environmentControlRoom: any = "";
  environmentAPIKey: any = "";

  addEnvironmentName: any = "";
  addEnvironmentControlRoom: any = "";
  addEnvironmentAPIKey: any = "";
  addEnvironmentUsername: any = "";
  addEnvironmentPassword: any = "";
  ed_environmentUsername: any = "";
  ed_EnvironmentAPIKey: any = "";
  ed_EnvironmentPassword: any = "";
  ed_status: any = "";
  ed_environmentName: any = "";
  ed_environmentControlRoom: any = "";

  isEnvironmentNameEmpty: boolean = false;
  isControlRoomEmpty: boolean = false;
  isEnvironmentAPIKeyEmpty: boolean = false;
  isAddEnvironmentShown: boolean = false;
  isEnvironmentUsernameEmpty: boolean = false;
  isEnvironmentPasswordEmpty: boolean = false;
  isEditEnvironmentUsernameEmpty: boolean = false;
  isEditEnvironmentAPIKeyEmpty: boolean = false;
  isEditEnvironmentPasswordEmpty: boolean = false;
  isEditEnvironmentNameEmpty: boolean = false;
  isEditEnvControlRoomEmpty: boolean = false;
  
  // stripe
  showStripePayment: boolean = false;
  clientSecret: string;
  stripeIntentId: string;
  initiatePayment: Subject<boolean> = new Subject();
  showNocardsFound: boolean;
  showPaymentDetails: boolean;
  cardLast4Digits: string;
  cardExpiryDate: string;
  cardBrandName: string;


  // Adding Environment
  environmentType: string;

  addOrganisationName: string;
  addTenantName: string;
  addAccountId: string;
  addAccountSecret: string;

  isAccountIdEmpty: boolean;
  isTenantEmpty: boolean;
  isOrganisationNameEmpty: boolean;
  isAccountSecretEmpty: boolean;

  showValidationErrors: boolean;

  showNewAdButton: boolean = true;
  showdirSetupModal: boolean = false;

  constructor(private _restService: RestService, private router: Router, private route: ActivatedRoute) {}

  ngOnInit() {
    var superAdmin = localStorage.getItem("isSuper");
    superAdmin !== "1"
      ? (localStorage.clear(), this.router.navigate([""]))
      : "";

    this.isLoading = true;
    this.countries = countryLists.country;
    this.states = stateLists.state;
    this.cities = cityLists;
    this.isSuperUser = localStorage.getItem("isSuper");
    this._restService
      .gettingSubscription()
      .pipe(
        catchError((e) => {
          (this.isFailure = true), (this.failureMessage = e.error.StatusInfo);
          console.log("Onload Error --->", e.error);
          return e;
        })
      )
      .subscribe(
        (f: any) => (
          (this.subscriptionDetails = f),
          (this.switch = this.subscriptionDetails.userObj.AccountSuspended),
          (this.totalSubscription = this.subscriptionDetails.userObj.totalSubscription),
          (this.actualSubcriberCount = this.subscriptionDetails.userObj.totalSubscription),
          (this.price = this.subscriptionDetails.userObj.PricePerSubscription),
          (this.totalAmount =
            this.price * this.totalSubscription + this.proratedfee),
          (this.transactionDetails = this.subscriptionDetails.transactionRes)
        )
      );

    this._restService
      .getIntegrationDetail()
      .pipe(
        catchError((e) => {
          (console.log(e), (this.isFailure = true)),
            (this.failureMessage = e.error.StatusInfo);
          return e;
        })
      )
      .subscribe(
        (f: any) => (
          console.log("Automation", f),
          (this.getIntegration = f),
          (this.url = this.getIntegration.orgdetails.AD_URL),
          (this.basedn = this.getIntegration.orgdetails.AD_BaseDN),
          (this.adusername = this.getIntegration.orgdetails.AD_UserName),
          (this.adpassword = this.getIntegration.orgdetails.AD_PassWord),
          (this.oktaorgurl = this.getIntegration.orgdetails.OKTA_Org_URL),
          (this.oktatoken = this.getIntegration.orgdetails.OKTA_Token),
          (this.crurl = this.getIntegration.orgdetails.ControlRoomURL),
          (this.crusername = this.getIntegration.orgdetails.AA_UserName),
          (this.crpassword = this.getIntegration.orgdetails.AA_PassWord),
          this.getIntegration.orgdetails.IntegrationType === 1
            ? (this.isADUser = false)
            : (this.isADUser = true),
          this.showNewAdButton = !this.oktaorgurl && !this.adusername
        )
      );

    this._restService
      .getAccountDetails()
      .pipe(
        catchError((e) => {
          (this.isFailure = true), (this.failureMessage = e.error.StatusInfo);
          console.log("Onload Error --->", e.error);
          return e;
        })
      )
      .subscribe(
        (f: any) => (
          (this.companyDetails = f.CompanyObj),
          (this.companyname = f.CompanyObj.companyName),
          (this.streetaddress = f.CompanyObj.streetAddress),
          (this.cityid = f.CompanyObj.city),
          (this.stateid = f.CompanyObj.state),
          (this.countryid = f.CompanyObj.country),
          (this.cityname = f.CompanyObj.city),
          (this.statename = f.CompanyObj.state),
          (this.countryname = f.CompanyObj.country),
          (this.zipcode = f.CompanyObj.zipCode),
          (this.timezone = f.CompanyObj.timeZone),
          (this.timezonename = f.CompanyObj.timeZone),
          (this.firstname = f.superAdminObj.FirstName),
          (this.lastname = f.superAdminObj.LastName),
          (this.phone = f.superAdminObj.Phone),
          (this.email = f.superAdminObj.Email),
          (this.altphone = f.superAdminObj.AltPhone)
        )
      );

    var month = new Array();
    month[0] = "January";
    month[1] = "February";
    month[2] = "March";
    month[3] = "April";
    month[4] = "May";
    month[5] = "June";
    month[6] = "July";
    month[7] = "August";
    month[8] = "September";
    month[9] = "October";
    month[10] = "November";
    month[11] = "December";

    var d = new Date();
    var m = month[d.getMonth() + 1];
    var y = d.getFullYear();
    this.month = m;
    this.year = y;

    this.isLoading = false;

    this._restService.timezone.subscribe(
      (t) => ((this.timezonename = t.text), (this.istimezonenameEmpty = false))
    );

    this._restService
      .environmentMasterList()
      .pipe(
        catchError((e) => {
          (this.isFailure = true), (this.failureMessage = e.error.StatusInfo);
          console.log("Onload Error --->", e.error);
          return e;
        })
      )
      .subscribe((f: any) =>
        console.log("environment", (this.environmentList = f.EnvList))
      );

      const token = this.route.snapshot.paramMap.get("token");

      if (token) {
        this.isLoading = true;
        this._restService
        .verifyPayment(decodeURIComponent(token))
        .pipe(
          catchError((e) => {
           this.isLoading = false;
           this.isFailure = true;
           this.failureMessage = e && e.error && e.error.StatusInfo;
           return e;
          })
        )
        .subscribe((f: any) => {
          this.isLoading = false;
          this.isSuccess = true;
          this.successMessage = f.StatusInfo;
        });
      }
  }

  confirmFailureMessage() {
    this.isFailure = false;
    this.failureMessage === "Session Expired"
      ? (localStorage.clear(),
        (this.failureMessage = ""),
        this.router.navigate([""]))
      : (this.failureMessage = "");
  }

  confirmSuccessMessage() {
    this.isSuccess = false;
    this.successMessage = "";
  }

  deletingAccount() {
    this.isDeleteModelShown = true;
  }

  confirmDeletingAccount() {
    this.isDeleteModelShown = false;
    this.isLoading = true;
    this._restService
      .deleteSubcription()
      .pipe(
        catchError((e) => {
          console.log("err --->", e);
          this.isLoading = false;
          this.isFailure = true;
          this.failureMessage = e.error.StatusInfo;
          return e;
        })
      )
      .subscribe(
        (f: any) => (
          (this.isLoading = false),
          localStorage.clear(),
          this.router.navigate([""])
        )
      );
  }

  cancelingDeletingAccount() {
    this.isDeleteModelShown = false;
  }

  suspendingAccount(id: any) {
    this.suspendId = id;
    this.isSuspendModelShown = true;
  }

  revoke(id: any) {
    this.suspendId = id;
    this.isRevokeModelShown = true;
  }

  confirmSuspendAccount() {
    this.isSuspendModelShown = false;
    this.isLoading = true;
    this._restService
      .suspendingSubcription(this.suspendId)
      .pipe(
        catchError((e) => {
          console.log("err --->", e);
          this.isLoading = false;
          this.isFailure = true;
          this.failureMessage = e.error.StatusInfo;
          return e;
        })
      )
      .subscribe(
        (f: any) => (
          console.log("Suspend", f),
          (this.isLoading = false),
          (this.isSuspendModelShown = false),
          (this.isSuccess = true),
          (this.successMessage = f.StatusInfo),
          this._restService
            .gettingSubscription()
            .pipe(
              catchError((e) => {
                console.log("err --->", e);
                this.isFailure = true;
                this.failureMessage = e.error.StatusInfo;
                return e;
              })
            )
            .subscribe(
              (f: any) => (
                (this.subscriptionDetails = f),
                (this.switch = this.subscriptionDetails.userObj.AccountSuspended),
                (this.totalSubscription = this.subscriptionDetails.userObj.totalSubscription),
                (this.actualSubcriberCount = this.subscriptionDetails.userObj.totalSubscription),
                (this.price = this.subscriptionDetails.userObj.PricePerSubscription),
                (this.totalAmount =
                  this.price * this.totalSubscription + this.proratedfee),
                (this.isLoading = false),
                console.log("this.switch", this.switch)
              )
            )
        )
      );
  }

  confirmRevokeAccount() {
    this.isRevokeModelShown = false;
    this.isLoading = true;
    this._restService
      .suspendingSubcription(this.suspendId)
      .pipe(
        catchError((e) => {
          console.log("err --->", e);
          this.isLoading = false;
          this.isFailure = true;
          this.failureMessage = e.error.StatusInfo;
          return e;
        })
      )
      .subscribe(
        (f: any) => (
          console.log("Revooooke", f),
          (this.isLoading = false),
          (this.isSuccess = true),
          (this.successMessage = f.StatusInfo),
          this._restService
            .gettingSubscription()
            .pipe(
              catchError((e) => {
                console.log("err --->", e);
                this.isFailure = true;
                this.failureMessage = e.error.StatusInfo;
                return e;
              })
            )
            .subscribe(
              (f: any) => (
                (this.subscriptionDetails = f),
                (this.switch = this.subscriptionDetails.userObj.AccountSuspended),
                (this.totalSubscription = this.subscriptionDetails.userObj.totalSubscription),
                (this.actualSubcriberCount = this.subscriptionDetails.userObj.totalSubscription),
                (this.price = this.subscriptionDetails.userObj.PricePerSubscription),
                (this.totalAmount =
                  this.price * this.totalSubscription + this.proratedfee),
                (this.isLoading = false),
                console.log("this.switch", this.switch)
              )
            )
        )
      );
  }

  cancelingSuspendAccount() {
    this.isSuspendModelShown = false;
  }

  cancelingRevokeAccount() {
    this.isRevokeModelShown = false;
  }

  paymentModel() {
    this.isEditClicked = false;
    this.isPaymentModelShown = true;
    this.showStripePayment = false;
    this.isPaymentFailed = false;
    this.isPaymentSuccess = false;

    this.isErrorUpdateCreditCardDetails = false;
    this.UpdateCreditCardDetailsMsg = "";
    this.isPaymentSuccess = false;
    this.UpdateCreditCardDetailsMsg = "";

    this.isCardnumberEmpty = false;
    this.isExpireDateEmpty = false;
    this.iscvvEmpty = false;

    this.showNocardsFound = false;
    this.showPaymentDetails = false;
    this.isLoading = true;


    this._restService
      .retrievePayment()
      .pipe(
        catchError((e) => {
          this.showNocardsFound = true;
          this.paymentFailedMessage = 'No card Found';
          this.isLoading = false;
          return e;
        })
      )
      .subscribe(
        (f: any) => {
          this.showPaymentDetails = true;
          this.isLoading = false;
          this.cardLast4Digits = f.paymentInfo.last4;
          this.cardExpiryDate = `${f.paymentInfo.exp_month}/${f.paymentInfo.exp_year}`;
          this.cardBrandName = f.paymentInfo.brand;
        }
      );
  }

  editCreditCardDetails() {

    /*
    this.isEditClicked = true;
    this.clientSecret = 'seti_1NGJudFpraaQp5PrdQLLRklv_secret_O2OityquFr7Z2OX0brM7HnnGMHEvJlc';
    this.stripeIntentId = 'U2FsdGVkX1+pH7IrswARl03tL5IknQTqvV1c4O3E1dNNwixOiqbn5A4ipMZCSTM1';
    this.showStripePayment = true;
    */
    
    this.showNocardsFound = false;
    this.showPaymentDetails = false;
    this.isLoading = true;

    this._restService
      .setupPaymentIntent(this.email)
      .pipe(
        catchError((e) => {
          console.log("err --->", e);
          this.showNocardsFound = true;
          this.isLoading = false;
          this.paymentFailedMessage = e.error.StatusInfo;
          return e;
        })
      )
      .subscribe(
        (f: any) => {
          this.isEditClicked = true;
          this.isLoading = false;
          this.clientSecret = f.clientSecret;
          this.stripeIntentId = f.intentId;
          this.showStripePayment = true;
        }
      );
      
  }

  addNewDirectory() {
    this.showdirSetupModal = true;
  }

  closeDirModal(type: any) {
    this.showdirSetupModal = false;
    this.showNewAdButton = !type;
    
    if (type) {
      this.integrationsCancelEvent();
    }
  }

  cancelCreditCardDetails() {
    this.isPaymentModelShown = false;
    this.cvv = "XXX";
    this.showStripePayment = false;
  }

  onChangeCardnumber(e: any) {
    this.isCardnumberEmpty = false;
    this.isErrorUpdateCreditCardDetails = false;
    this.UpdateCreditCardDetailsMsg = "";
    this.isPaymentSuccess = false;
    this.UpdateCreditCardDetailsMsg = "";

    e.target.value.substring(0, 1) === " "
      ? ((e.target.value = ""),
        (this.cardnumber = ""),
        (this.isCardnumberEmpty = true))
      : (this.isCardnumberEmpty = false);
  }

  onChangeExpireDate(e: any) {
    this.isExpireDateEmpty = false;
    this.isErrorUpdateCreditCardDetails = false;
    this.UpdateCreditCardDetailsMsg = "";
    this.isPaymentSuccess = false;
    this.UpdateCreditCardDetailsMsg = "";

    e.target.value.substring(0, 1) === " "
      ? ((e.target.value = ""),
        (this.expireDate = ""),
        (this.isExpireDateEmpty = true))
      : (this.isExpireDateEmpty = false);
  }

  onChangecvv(e: any) {
    this.iscvvEmpty = false;
    this.isErrorUpdateCreditCardDetails = false;
    this.UpdateCreditCardDetailsMsg = "";
    this.isPaymentSuccess = false;
    this.UpdateCreditCardDetailsMsg = "";

    e.target.value.substring(0, 1) === " "
      ? ((e.target.value = ""), (this.cvv = ""), (this.iscvvEmpty = true))
      : (this.iscvvEmpty = false);
  }

  apikeyEvent(e: any) {
    this.isAPIKeySelected = true;
    this.isPasswordSelected = false;
    this.isEditEnvironmentAPIKeyEmpty = false;
    this.isEditEnvironmentPasswordEmpty = false;
    this.addEnvironmentAPIKey = "";
    this.isEnvironmentAPIKeyEmpty = false;
  }

  passwordEvent(e: any) {
    this.isAPIKeySelected = false;
    this.isPasswordSelected = true;
    this.isEditEnvironmentAPIKeyEmpty = false;
    this.isEditEnvironmentPasswordEmpty = false;
    this.addEnvironmentPassword = "";
    this.isEnvironmentPasswordEmpty = false;
  }

  updateCreditCardDetails() {
    this.initiatePayment.next(true);
  }

  editSubscribe() {
    this.isEditSubModelShown = true;
    this.isAddedNewSubscribe = false;
    this.isReducedNewSubscribe = false;
    this.isTransactionError = false;
    this.isTransactionSuccess = false;

    this._restService
      .gettingSubscription()
      .pipe(
        catchError((e) => {
          console.log("err --->", e);
          this.isEditSubModelShown = false;
          this.isFailure = true;
          this.failureMessage = e.error.StatusInfo;
          return e;
        })
      )
      .subscribe(
        (f: any) => (
          (this.subscriptionDetails = f),
          (this.totalSubscription = this.subscriptionDetails.userObj.totalSubscription),
          (this.actualSubcriberCount = this.subscriptionDetails.userObj.totalSubscription),
          (this.price = this.subscriptionDetails.userObj.PricePerSubscription)
        )
      );
    this.totalAmount = this.price * this.totalSubscription + this.proratedfee;
  }

  cancelEditSubscribe() {
    this.isEditSubModelShown = false;

    this._restService
      .gettingSubscription()
      .pipe(
        catchError((e) => {
          (this.isFailure = true), (this.failureMessage = e.error.StatusInfo);
          console.log("Onload Error --->", e.error);
          return e;
        })
      )
      .subscribe(
        (f: any) => (
          (this.subscriptionDetails = f),
          (this.switch = this.subscriptionDetails.userObj.AccountSuspended),
          (this.totalSubscription = this.subscriptionDetails.userObj.totalSubscription),
          (this.actualSubcriberCount = this.subscriptionDetails.userObj.totalSubscription),
          (this.price = this.subscriptionDetails.userObj.PricePerSubscription),
          (this.totalAmount =
            this.price * this.totalSubscription + this.proratedfee),
          (this.transactionDetails = this.subscriptionDetails.transactionRes)
        )
      );
  }

  increaseSubcription() {
    var inc: any;
    var d = new Date();
    var currentDate = d.getDate();
    var currentMonth = d.getMonth() + 1;
    var currentYear = d.getFullYear();
    var noofdays = new Date(currentYear, currentMonth, 0).getDate();
    var prorateAmount: any = 0;

    this.isTransactionError = false;
    this.isTransactionSuccess = false;

    (inc = this.totalSubscription + 1),
      inc > this.actualSubcriberCount
        ? ((this.isAddedNewSubscribe = true),
          (this.isReducedNewSubscribe = false))
        : (this.isAddedNewSubscribe = false),
      inc === this.actualSubcriberCount
        ? (this.isReducedNewSubscribe = false)
        : "",
      (this.totalSubscription = inc);

    console.log(
      noofdays +
        "--" +
        currentDate +
        "---" +
        this.price +
        "---" +
        this.totalSubscription +
        "---" +
        this.actualSubcriberCount
    );

    this.totalSubscription > this.actualSubcriberCount
      ? ((prorateAmount =
          ((noofdays - currentDate) / noofdays) *
          this.price *
          (this.totalSubscription - this.actualSubcriberCount)),
        (this.proratedfee = Number(prorateAmount.toFixed(2))))
      : "";

    this.totalAmount = this.price * this.totalSubscription + this.proratedfee;
  }

  decreaseSubcription() {
    var dec: any;
    var d = new Date();
    var currentDate = d.getDate();
    var currentMonth = d.getMonth() + 1;
    var currentYear = d.getFullYear();
    var noofdays = new Date(currentYear, currentMonth, 0).getDate();
    var prorateAmount: any = 0;

    this.isTransactionError = false;
    this.isTransactionSuccess = false;

    this.totalSubscription > 1
      ? ((dec = this.totalSubscription - 1),
        dec < this.actualSubcriberCount
          ? ((this.isAddedNewSubscribe = false),
            (this.isReducedNewSubscribe = true))
          : ((this.isAddedNewSubscribe = true),
            (this.isReducedNewSubscribe = false)),
        dec === this.actualSubcriberCount
          ? (this.isAddedNewSubscribe = false)
          : "",
        (this.totalSubscription = dec))
      : "";

    this.totalSubscription < this.actualSubcriberCount
      ? (this.proratedfee = 0)
      : ((prorateAmount =
          ((noofdays - currentDate) / noofdays) *
          this.price *
          (this.totalSubscription - this.actualSubcriberCount)),
        (this.proratedfee = Number(prorateAmount.toFixed(2))));

    this.totalAmount = this.price * this.totalSubscription - this.proratedfee;
  }

  changingSubcribeCount(e: any) {
    e.target.value = e.target.value.replace(/[^0-9]/g, "").trim();

    let val = e.target.value;
    var d = new Date();
    var currentDate = d.getDate();
    var currentMonth = d.getMonth() + 1;
    var currentYear = d.getFullYear();
    var noofdays = new Date(currentYear, currentMonth, 0).getDate();
    var prorateAmount: any = 0;

    this.isTransactionError = false;
    this.isTransactionSuccess = false;

    e.which === 189 || val === "0"
      ? ((e.target.value = "1"), (this.totalSubscription = 1))
      : val === ""
      ? ((e.target.value = "1"),
        (this.isSubscriptionEmpty = true),
        (this.totalSubscription = 1))
      : ((this.isSubscriptionEmpty = false),
        (this.totalSubscription = parseInt(val)),
        parseInt(val) > this.actualSubcriberCount
          ? ((this.isAddedNewSubscribe = true),
            (this.isReducedNewSubscribe = false))
          : parseInt(val) < this.actualSubcriberCount
          ? ((this.isAddedNewSubscribe = false),
            (this.isReducedNewSubscribe = true))
          : parseInt(val) === this.actualSubcriberCount
          ? ((this.isAddedNewSubscribe = false),
            (this.isReducedNewSubscribe = false))
          : "");

    val > this.actualSubcriberCount
      ? ((prorateAmount =
          ((noofdays - currentDate) / noofdays) *
          this.price *
          (this.totalSubscription - this.actualSubcriberCount)),
        (this.proratedfee = Number(prorateAmount.toFixed(2))),
        (this.totalAmount =
          this.price * this.totalSubscription + this.proratedfee))
      : "";

    val < this.actualSubcriberCount
      ? ((this.proratedfee = 0),
        (this.totalAmount =
          this.price * this.totalSubscription - this.proratedfee))
      : "";

    val === this.actualSubcriberCount
      ? ((this.proratedfee = 0),
        (this.totalAmount =
          this.price * this.totalSubscription + this.proratedfee))
      : "";
  }

  updateSubcribe() {
    this.isLoading = true;
    this._restService
      .updatingSubscriptionCount(
        this.proratedfee,
        this.totalSubscription,
        this.firstname,
        this.lastname,
        this.email
      )
      .pipe(
        catchError((e) => {
          console.log("erwwwewer --->", e);
          this.isLoading = false;
          this.isTransactionError = true;
          this.isTransactionSuccess = false;
          this.failureMessage = e.error.StatusInfo;
          return e;
        })
      )
      .subscribe(
        (f: any) => (
          (this.isLoading = false),
          (this.isTransactionSuccess = true),
          (this.isTransactionError = false),
          (this.transactionSuccessMessage = f.StatusInfo)
        )
      );
  }

  editCompanyDetails() {
    let st: any = "";
    let ct: any = "";

    console.log(
      this.countryname + "----" + this.statename + "----" + this.cityname
    );

    this.countries.filter((c: any) =>
      c.CountryName === this.countryname ? (this.country = c.CounryId) : ""
    );

    st = this.states[this.country];
    this.stateList = st;
    st.filter((s: any) =>
      s.name === this.statename ? (this.state = s.id) : ""
    );

    ct = this.cities.city[this.state];

    this.cityList =
      ct === undefined
        ? [
            {
              id: "000",
              name: "No City",
              state_id: "000",
            },
          ]
        : ct;

    this.cityList.filter((c: any) =>
      c.name === "No City"
        ? ((this.city = c.id), (this.cityname = c.name))
        : (this.city = c.id)
    );
    this.isCompanyEditBtnClicked = true;
    //this.timezonename = "";
  }

  onChangeCountryEvent(cid: string) {
    this.state = "";
    this.statename = "";
    this.cityname = "";

    this.countryid = parseInt(cid);
    this.countries.filter((c: any) =>
      c.CounryId === this.countryid ? (this.countryname = c.CountryName) : ""
    );

    var st = this.states[cid];
    this.stateList = st;
    this.cityList = [];
    console.log("this.state", this.state);
  }

  onChangeStateEvent(sid: string) {
    this.stateid = parseInt(sid);
    this.stateList.filter((s: any) =>
      s.id === this.stateid ? (this.statename = s.name) : ""
    );

    var cl = this.cities.city[sid];
    // this.cityList = cl;
    this.cityList =
      cl === undefined
        ? [
            {
              id: "000",
              name: "No City",
              state_id: "000",
            },
          ]
        : cl;

    console.log(this.cityList);
  }

  onChangeCityEvent(ctid: any) {
    this.cityList.filter((c: any) =>
      c.name === "No City"
        ? (this.cityname = c.name)
        : this.cityList.filter((c: any) =>
            c.id === parseInt(ctid) ? (this.cityname = c.name) : ""
          )
    );
  }

  onChangeTimeZone(zid: any) {
    this.timezonename = zid;
  }

  cancelEditingCompanyDetails() {
    this.isCompanyEditBtnClicked = false;
    this.istimezonenameEmpty = false;
    this.isZipcodeEmpty = false;
    this.isCitynameEmpty = false;
    this.isStatenameEmpty = false;
    this.isCountrynameEmpty = false;
    this.isStreetaddressEmpty = false;
    this.isCompanynameEmpty = false;

    this.isFilled = false;

    this.companyname = "";
    this.streetaddress = "";
    this.city = "";
    this.state = "";
    this.zipcode = "";
    this.timezone = "";

    this._restService
      .getAccountDetails()
      .pipe(
        catchError((e) => {
          (this.isFailure = true), (this.failureMessage = e.error.StatusInfo);
          console.log("Onload Error --->", e.error);
          return e;
        })
      )
      .subscribe(
        (f: any) => (
          (this.companyDetails = f.CompanyObj),
          (this.companyname = f.CompanyObj.companyName),
          (this.streetaddress = f.CompanyObj.streetAddress),
          (this.cityid = f.CompanyObj.city),
          (this.stateid = f.CompanyObj.state),
          (this.countryid = f.CompanyObj.country),
          (this.cityname = f.CompanyObj.city),
          (this.statename = f.CompanyObj.state),
          (this.countryname = f.CompanyObj.country),
          (this.zipcode = f.CompanyObj.zipCode),
          (this.timezone = f.CompanyObj.timeZone),
          (this.timezonename = f.CompanyObj.timeZone),
          (this.firstname = f.superAdminObj.FirstName),
          (this.lastname = f.superAdminObj.LastName),
          (this.phone = f.superAdminObj.Phone),
          (this.email = f.superAdminObj.Email),
          (this.altphone = f.superAdminObj.AltPhone)
        )
      );
  }

  onChangeCompanyname(e: any) {
    e.target.value.substring(0, 1) === " "
      ? ((e.target.value = ""),
        (this.companyname = ""),
        (this.isCompanynameEmpty = true))
      : (this.isCompanynameEmpty = false);
  }

  onChangeStreetaddress(e: any) {
    e.target.value.substring(0, 1) === " "
      ? ((e.target.value = ""),
        (this.streetaddress = ""),
        (this.isStreetaddressEmpty = true))
      : (this.isStreetaddressEmpty = false);
  }

  onChangeZipcode(e: any) {
    e.target.value.substring(0, 1) === " "
      ? ((e.target.value = ""),
        (this.zipcode = ""),
        (this.isZipcodeEmpty = true))
      : (this.isZipcodeEmpty = false);
  }

  updateCompanyDetails() {
    this.companyname === ""
      ? ((this.isCompanynameEmpty = true), (this.isFilled = true))
      : (this.isCompanynameEmpty = false);
    this.streetaddress === ""
      ? ((this.isStreetaddressEmpty = true), (this.isFilled = true))
      : (this.isStreetaddressEmpty = false);
    this.countryname === ""
      ? ((this.isCountrynameEmpty = true), (this.isFilled = true))
      : (this.isCountrynameEmpty = false);
    this.statename === ""
      ? ((this.isStatenameEmpty = true), (this.isFilled = true))
      : (this.isStatenameEmpty = false);
    this.cityname === ""
      ? ((this.isCitynameEmpty = true), (this.isFilled = true))
      : (this.isCitynameEmpty = false);
    this.zipcode === ""
      ? ((this.isZipcodeEmpty = true), (this.isFilled = true))
      : (this.isZipcodeEmpty = false);
    this.timezonename === "" || this.timezonename === undefined
      ? ((this.istimezonenameEmpty = true), (this.isFilled = true))
      : (this.istimezonenameEmpty = false);

    console.log("Suceess city", this.timezonename);

    if (
      this.companyname !== "" &&
      this.streetaddress !== "" &&
      this.countryname !== "" &&
      this.statename !== "" &&
      this.cityname !== "" &&
      this.zipcode !== "" &&
      this.timezonename !== ""
    ) {
      this.isFilled = false;
      this.isLoading = true;
      this.isCompanyEditBtnClicked = false;
      this._restService
        .editAccountDetails(
          this.companyname,
          this.streetaddress,
          this.country,
          this.state,
          this.city,
          this.zipcode,
          this.timezonename,
          this.email,
          this.firstname,
          this.lastname
        )
        .pipe(
          catchError((e) => {
            console.log("err --->", e);
            this.isLoading = false;
            this.isFailure = true;
            this.failureMessage = e.error.StatusInfo;
            return e;
          })
        )
        .subscribe(
          (f: any) => (
            (this.isLoading = false),
            (this.isSuccess = true),
            (this.successMessage = f.StatusInfo),
            this._restService
              .getAccountDetails()
              .pipe(
                catchError((e) => {
                  (this.isFailure = true),
                    (this.failureMessage = e.error.StatusInfo);
                  console.log("Onload Error --->", e.error);
                  return e;
                })
              )
              .subscribe(
                (f: any) => (
                  (this.companyDetails = f.CompanyObj),
                  (this.companyname = f.CompanyObj.companyName),
                  (this.streetaddress = f.CompanyObj.streetAddress),
                  (this.cityid = f.CompanyObj.city),
                  (this.stateid = f.CompanyObj.state),
                  (this.countryid = f.CompanyObj.country),
                  (this.cityname = f.CompanyObj.city),
                  (this.statename = f.CompanyObj.state),
                  (this.countryname = f.CompanyObj.country),
                  (this.zipcode = f.CompanyObj.zipCode),
                  (this.timezone = f.CompanyObj.timeZone),
                  (this.timezonename = f.CompanyObj.timeZone),
                  (this.firstname = f.superAdminObj.FirstName),
                  (this.lastname = f.superAdminObj.LastName),
                  (this.phone = f.superAdminObj.Phone),
                  (this.email = f.superAdminObj.Email),
                  (this.altphone = f.superAdminObj.AltPhone),
                  
                  timezoneArrayList.forEach( (f: any) => {
                    if (f.text.toString().toLowerCase() == this.timezone.toString().toLowerCase()){
                      localStorage.setItem('selectedTimeZone', f.value);
                      localStorage.setItem('timezoneName', f.timezone);
                      localStorage.setItem('timezoneOffset', f.offset)
                    }
                  })
                )
              )
          )
        );
    }
  }

  adminTransferEvent() {
    this.username = "";
    this.userEmailAddress = "";

    this.isTransferModelShown = true;
    this.isUserEmailAddress = false;
    this.isUserPhoneNumber = false;
    this.isUserrole = false;
    this.isAdminPassword = false;

    this._restService
      .getAdminTransferDetails()
      .pipe(
        catchError((e) => {
          (this.isFailure = true), (this.failureMessage = e.error.StatusInfo);
          console.log("Onload Error --->", e.error);
          return e;
        })
      )
      .subscribe(
        (f: any) => (
          (this.userList = f.userList),
          (this.roleList = f.roleList),
          console.log(this.userList + "-----" + this.roleList)
        )
      );
  }

  cancelAdminRoleModel() {
    this.isTransferModelShown = false;
    this.userEmailAddress = "";
    this.username = "";
  }

  checkRole(e: any) {
    e.target.checked === true
      ? ((this.isRolechecked = true), (this.convertRole = "1"))
      : ((this.isRolechecked = false), (this.convertRole = "0"));
  }

  changingRole(e: any) {
    this.roleId = e;
  }

  changeUsertoadmin(id: any) {
    this.userid = id;
    this.userList.filter((f: any) =>
      parseInt(f.id) === parseInt(id)
        ? ((this.userEmailAddress = f.email),
          (this.adminFirstname = f.firstName),
          (this.adminLastname = f.lastName))
        : ""
    );
  }

  integrationsTestEvent() {
    this.isLoading = true;
    this.getIntegration.orgdetails.IntegrationType === 1
      ? (this.oktaorgurl === ""
          ? (this.isOktaorgurlEmpty = true)
          : (this.isOktaorgurlEmpty = false),
        this.oktatoken === ""
          ? (this.isOktatokenEmpty = true)
          : (this.isOktatokenEmpty = false),
        this.oktaorgurl !== "" && this.oktatoken !== ""
          ? this._restService
              .testIntegrationConnection(
                this.getIntegration.orgdetails.IntegrationType,
                this.oktaorgurl,
                this.oktatoken,
                null,
                null,
                null,
                null
              )
              .pipe(
                catchError((e) => {
                  (this.isLoading = false),
                    (this.integrationsEdit = false),
                    (this.integrationsSave = true),
                    (this.isFailure = true),
                    (this.failureMessage = e.error.StatusInfo);
                  console.log("Onload Error --->", e.error);
                  return e;
                })
              )
              .subscribe(
                (f: any) => (
                  console.log(f),
                  (this.isLoading = false),
                  (this.integrationsEdit = true),
                  (this.integrationsSave = false),
                  (this.isSuccess = true),
                  (this.successMessage = f.StatusInfo)
                )
              )
          : "")
      : "";

    this.getIntegration.orgdetails.IntegrationType === 2
      ? (this.url === "" ? (this.isUrlEmpty = true) : (this.isUrlEmpty = false),
        this.basedn === ""
          ? (this.isBasednEmpty = true)
          : (this.isBasednEmpty = false),
        this.adusername === ""
          ? (this.isUsernameEmpty = true)
          : (this.isUsernameEmpty = false),
        this.adpassword === ""
          ? (this.isPasswordEmpty = true)
          : (this.isPasswordEmpty = false),
        this.url !== "" &&
        this.basedn !== "" &&
        this.adusername !== "" &&
        this.adpassword !== ""
          ? this._restService
              .testIntegrationConnection(
                this.getIntegration.orgdetails.IntegrationType,
                null,
                null,
                this.url,
                this.basedn,
                this.adusername,
                this.adpassword
              )
              .pipe(
                catchError((e) => {
                  (this.isLoading = false),
                    (this.integrationsEdit = false),
                    (this.integrationsSave = true),
                    (this.isFailure = true),
                    (this.failureMessage = e.error.StatusInfo);
                  console.log("Onload Error --->", e.error);
                  return e;
                })
              )
              .subscribe(
                (f: any) => (
                  console.log(f),
                  (this.isLoading = false),
                  (this.integrationsEdit = true),
                  (this.integrationsSave = false),
                  (this.isSuccess = true),
                  (this.successMessage = f.StatusInfo)
                )
              )
          : "")
      : "";
  }

  onChangePhone(e: any) {
    e.target.value.substring(0, 1) === " "
      ? ((e.target.value = ""),
        (this.userPhoneNumber = ""),
        (this.isUserPhoneNumber = true))
      : ((this.isUserPhoneNumber = false),
        (this.userPhoneNumber = e.target.value.replace(/[^0-9]/g, "").trim()));
  }

  onChangeAlterPhone(e: any) {
    e.target.value.substring(0, 1) === " "
      ? ((e.target.value = ""), (this.userAlterPhoneNumber = ""))
      : (this.userAlterPhoneNumber = e.target.value
          .replace(/[^0-9]/g, "")
          .trim());
  }

  onChangeAdminPassword(e: any) {
    e.target.value.substring(0, 1) === " "
      ? ((e.target.value = ""),
        (this.password = ""),
        (this.isAdminPassword = true))
      : (this.isAdminPassword = false);
  }

  onChangeUrl(e: any) {
    e.target.value.substring(0, 1) === " "
      ? ((e.target.value = ""), (this.url = ""), (this.isUrlEmpty = true))
      : (this.isUrlEmpty = false);
  }

  onChangeBasedn(e: any) {
    e.target.value.substring(0, 1) === " "
      ? ((e.target.value = ""), (this.basedn = ""), (this.isBasednEmpty = true))
      : (this.isBasednEmpty = false);
  }

  onChangeUsername(e: any) {
    e.target.value.substring(0, 1) === " "
      ? ((e.target.value = ""),
        (this.adusername = ""),
        (this.isUsernameEmpty = true))
      : (this.isUsernameEmpty = false);
  }

  onChangePassword(e: any) {
    e.target.value.substring(0, 1) === " "
      ? ((e.target.value = ""),
        (this.adpassword = ""),
        (this.isPasswordEmpty = true))
      : (this.isPasswordEmpty = false);
  }

  integrationsSaveEvent() {
    this.isLoading = true;

    this.getIntegration.orgdetails.IntegrationType === 1
      ? (this.oktaorgurl === ""
          ? (this.isOktaorgurlEmpty = true)
          : (this.isOktaorgurlEmpty = false),
        this.oktatoken === ""
          ? (this.isOktatokenEmpty = true)
          : (this.isOktatokenEmpty = false),
        this.oktaorgurl !== "" && this.oktatoken !== ""
          ? ((this.integrationsEdit = true),
            (this.integrationsSave = false),
            this._restService
              .updateIntegrationDetail(
                this.getIntegration.orgdetails.IntegrationType,
                this.oktaorgurl,
                this.oktatoken,
                null,
                null,
                null,
                null,
                this.email,
                this.firstname,
                this.lastname
              )
              .pipe(
                catchError((e) => {
                  (this.isLoading = false),
                    (this.isFailure = true),
                    (this.failureMessage = e.error.StatusInfo);
                  console.log("Onload Error --->", e.error);
                  return e;
                })
              )
              .subscribe(
                (f: any) => (
                  console.log(f),
                  (this.isLoading = false),
                  (this.isSuccess = true),
                  (this.successMessage = f.StatusInfo)
                )
              ))
          : "")
      : "";

    this.getIntegration.orgdetails.IntegrationType === 2
      ? (this.url === "" ? (this.isUrlEmpty = true) : (this.isUrlEmpty = false),
        this.basedn === ""
          ? (this.isBasednEmpty = true)
          : (this.isBasednEmpty = false),
        this.adusername === ""
          ? (this.isUsernameEmpty = true)
          : (this.isUsernameEmpty = false),
        this.adpassword === ""
          ? (this.isPasswordEmpty = true)
          : (this.isPasswordEmpty = false),
        this.url !== "" &&
        this.basedn !== "" &&
        this.adusername !== "" &&
        this.adpassword !== ""
          ? ((this.integrationsEdit = true),
            (this.integrationsSave = false),
            this._restService
              .updateIntegrationDetail(
                this.getIntegration.orgdetails.IntegrationType,
                null,
                null,
                this.url,
                this.basedn,
                this.adusername,
                this.adpassword,
                this.email,
                this.firstname,
                this.lastname
              )
              .pipe(
                catchError((e) => {
                  (this.isLoading = false),
                    (this.isFailure = true),
                    (this.failureMessage = e.error.StatusInfo);
                  console.log("Onload Error --->", e.error);
                  return e;
                })
              )
              .subscribe(
                (f: any) => (
                  console.log(f),
                  (this.isLoading = false),
                  (this.isSuccess = true),
                  (this.successMessage = f.StatusInfo)
                )
              ))
          : "")
      : "";
  }

  integrationsEditEvent() {
    this.integrationsEdit = false;
    this.integrationsSave = true;
  }

  integrationsCancelEvent() {
    this.isUrlEmpty = false;
    this.isBasednEmpty = false;
    this.isUsernameEmpty = false;
    this.isPasswordEmpty = false;
    this.isOktaorgurlEmpty = false;
    this.isOktatokenEmpty = false;

    (this.integrationsEdit = true),
      (this.integrationsSave = false),
      this._restService
        .getIntegrationDetail()
        .pipe(
          catchError((e) => {
            (this.isFailure = true), (this.failureMessage = e.error.StatusInfo);
            return e;
          })
        )
        .subscribe(
          (f: any) => (
            (this.getIntegration = f),
            (this.url = this.getIntegration.orgdetails.AD_URL),
            (this.basedn = this.getIntegration.orgdetails.AD_BaseDN),
            (this.adusername = this.getIntegration.orgdetails.AD_UserName),
            (this.adpassword = this.getIntegration.orgdetails.AD_PassWord),
            (this.oktaorgurl = this.getIntegration.orgdetails.OKTA_Org_URL),
            (this.oktatoken = this.getIntegration.orgdetails.OKTA_Token),
            this.showNewAdButton = !this.oktaorgurl && !this.adusername,
            this.getIntegration.orgdetails.IntegrationType === 1
              ? (this.isADUser = false)
              : (this.isADUser = true)
          )
        );
  }

  confirmUserTransfer() {
    this.userEmailAddress === ""
      ? (this.isUserEmailAddress = true)
      : (this.isUserEmailAddress = false);
    this.userPhoneNumber === ""
      ? (this.isUserPhoneNumber = true)
      : (this.isUserPhoneNumber = false);
    this.userrole === "" && this.isRolechecked === true
      ? (this.isUserrole = true)
      : (this.isUserrole = false);
    this.password === ""
      ? (this.isAdminPassword = true)
      : (this.isAdminPassword = false);

    if (
      this.userEmailAddress !== "" &&
      this.userPhoneNumber !== "" &&
      this.userrole !== "" &&
      this.password !== ""
    ) {
      this.isLoading = true;
      this._restService
        .superAdminTransfer(
          this.userid,
          this.userPhoneNumber,
          this.userAlterPhoneNumber,
          this.convertRole,
          this.roleId,
          this.password,
          this.userEmailAddress,
          this.adminFirstname,
          this.adminLastname
        )
        .pipe(
          catchError((e) => {
            console.log("err --->", e);
            this.isLoading = false;
            this.isFailure = true;
            this.failureMessage = e.error.StatusInfo;
            return e;
          })
        )
        .subscribe(
          (f: any) => (
            (this.isLoading = false),
            (this.isTransferSucceed = true),
            setTimeout(() => {
              localStorage.clear();
              this.router.navigate([""]);
            }, 5000)
          )
        );
    }
  }

  onChangeOktaorgurl(e: any) {
    e.target.value.substring(0, 1) === " "
      ? ((e.target.value = ""),
        (this.oktaorgurl = ""),
        (this.isOktaorgurlEmpty = true))
      : (this.isOktaorgurlEmpty = false);
  }

  onChangeOktatoken(e: any) {
    e.target.value.substring(0, 1) === " "
      ? ((e.target.value = ""),
        (this.oktatoken = ""),
        (this.isOktatokenEmpty = true))
      : (this.isOktatokenEmpty = false);
  }

  automationTestEvent() {
    let AAType = this.isAPIKeySelected === true ? 0 : 1;
    let key = this.addEnvironmentAPIKey.replace(/\\/, "");
    this.isLoading = true;
    this._restService
      .testAAConnection(
        this.addEnvironmentName,
        this.addEnvironmentControlRoom,
        this.addEnvironmentUsername,
        key,
        this.addEnvironmentPassword,
        AAType
      )
      .pipe(
        catchError((e) => {
          console.log("err --->", e);
          this.isLoading = false;
          this.isFailure = true;
          this.failureMessage = e.error.AALoginErr;
          return e;
        })
      )
      .subscribe(
        (f: any) => (
          (this.isLoading = false),
          (this.isSuccess = true),
          (this.successMessage = f.StatusInfo)
        )
      );
  }

  editAutomationTestEvent() {
    let AAType = this.isAPIKeySelected === true ? 0 : 1;
    let key = this.ed_EnvironmentAPIKey
      ? this.ed_EnvironmentAPIKey.replace(/\\/, "")
      : "";
    this.isLoading = true;
    this._restService
      .testAAConnection(
        this.ed_environmentName,
        this.ed_environmentControlRoom,
        this.ed_environmentUsername,
        key,
        this.ed_EnvironmentPassword,
        AAType
      )
      .pipe(
        catchError((e) => {
          console.log("err --->", e);
          this.isLoading = false;
          this.isFailure = true;
          this.failureMessage = e.error.AALoginErr;
          return e;
        })
      )
      .subscribe(
        (f: any) => (
          (this.isLoading = false),
          (this.isSuccess = true),
          (this.successMessage = f.StatusInfo)
        )
      );
  }

  automationSaveEvent() {
    this.isLoading = true;
    this._restService
      .updateAADetail(this.crurl, this.crusername, this.crpassword)
      .pipe(
        catchError((e) => {
          console.log("err --->", e);
          this.isLoading = false;
          this.isFailure = true;
          this.failureMessage = e.error.StatusInfo;
          return e;
        })
      )
      .subscribe(
        (f: any) => (
          (this.isLoading = false),
          (this.isSuccess = true),
          (this.successMessage = f.StatusInfo)
        )
      );
  }

  addNewEnvironment() {
    this.addEnvironmentName = "";
    this.addEnvironmentControlRoom = "";
    this.addEnvironmentAPIKey = "";
    this.addEnvironmentUsername = "";
    this.addEnvironmentPassword = "";
    this.addAccountId = "";
    this.addTenantName = "";
    this.addAccountSecret = "";
    this.addOrganisationName = "";
    this.environmentType = "AA";

    this.isAddEnvironmentShown = true;
    this.isAPIKeySelected = true;
    this.isPasswordSelected = false;
    this.showValidationErrors = false;

    this.isEnvironmentUsernameEmpty = false;
    this.isEnvironmentAPIKeyEmpty = false;
    this.isEnvironmentPasswordEmpty = false;
    this.isAccountIdEmpty = true;
    this.isOrganisationNameEmpty = true;
    this.isTenantEmpty = true;
    this.isAccountSecretEmpty = true;
  }

  editEnvironmentModel(id: any, ename: any, cr: any, ak: any, env: any ){
    this.environmentType = env.Type;
    if (env.Type != 'UIPath') {
      this.editAAEnvironmentModel(id,ename, cr,  ak);
      return;
    }

    this.editUIPathEnvironmentModel(env);
  }

  editUIPathEnvironmentModel(env: any) {
    
    this.addAccountId = env.AA_UserName;

    const controlUrlArr = env.Control_Room_URL.split('/');
    this.addTenantName = controlUrlArr.length < 5 ? ' ' : controlUrlArr[4];
    this.addAccountSecret = '';
    this.addOrganisationName = controlUrlArr.length < 4 ? ' ' : controlUrlArr[3];
    this.ed_environmentName = env.environmentName;
    

    this.isEditEnvironmentShown = true;
    this.environmentId = env.envId;
    this.masterEnvironmentId = env.id;

    this.isAccountIdEmpty = !this.addAccountId;
    this.isOrganisationNameEmpty = !this.addOrganisationName;
    this.isTenantEmpty = !this.addTenantName;
    this.isAccountSecretEmpty = !this.addAccountSecret;
    this.isEditEnvironmentUsernameEmpty = !this.isEditEnvironmentUsernameEmpty;
  }

  editAAEnvironmentModel(eid: any, ename: any, cr: any, ak: any) {
    this._restService
      .environmentDetail(eid)
      .pipe(
        catchError((e) => {
          console.log("err --->", e);
          this.isLoading = false;
          this.isFailure = true;
          this.failureMessage = e.error.StatusInfo;
          return e;
        })
      )
      .subscribe(
        (f: any) => (
          console.log("f --->", f.EnvDetail),
          (this.isLoading = true),
          (this.environmentId = f.EnvDetail.id),
          (this.ed_environmentName = f.EnvDetail.Environment_Name),
          this.masterEnvironmentId = f.EnvDetail.MasterEnvId,
          (this.ed_environmentControlRoom = f.EnvDetail.Control_Room_URL),
          (this.ed_environmentUsername = f.EnvDetail.AA_UserName),
          (this.ed_EnvironmentAPIKey = f.EnvDetail.API_key),
          (this.ed_EnvironmentPassword = f.EnvDetail.Password),
          (this.ed_status = f.EnvDetail.AA_Type === 0 ? true : false),
          f.EnvDetail.AA_Type === 0
            ? ((this.isAPIKeySelected = true),
              (this.isPasswordSelected = false))
            : ((this.isAPIKeySelected = false),
              (this.isPasswordSelected = true)),
          (this.isEditEnvironmentShown = true),
          console.log(
            "After --->",
            this.environmentId +
              "---" +
              this.ed_environmentName +
              "---" +
              this.ed_environmentControlRoom +
              "---" +
              this.ed_environmentUsername +
              "---" +
              this.ed_EnvironmentAPIKey
          ),
          (this.isLoading = false)
        )
      );
  }

  onOrganisationName(e: any) {
    this.isOrganisationNameEmpty = !e.target.value.length;
  }

  onTenantName(e: any) {
    this.isTenantEmpty= !e.target.value.length;
  }

  onAccountId(e: any) {
    this.isAccountIdEmpty = !e.target.value.length;
  }

  onAccountSecret(e: any) {
    this.isAccountSecretEmpty = !e.target.value.length;
  }

  onEnvironmentName(e: any) {
    e.target.value.substring(0, 1) === " "
      ? ((e.target.value = ""),
        (this.environmentName = ""),
        (this.isEnvironmentNameEmpty = true))
      : (this.isEnvironmentNameEmpty = false);
  }

  onEnvironmentControlRoom(e: any) {
    e.target.value.substring(0, 1) === " "
      ? ((e.target.value = ""),
        (this.environmentControlRoom = ""),
        (this.isControlRoomEmpty = true))
      : (this.isControlRoomEmpty = false);
  }

  onEditEnvironmentUsername(e: any) {
    e.target.value.substring(0, 1) === " "
      ? ((e.target.value = ""),
        (this.ed_environmentUsername = ""),
        (this.isEditEnvironmentUsernameEmpty = true))
      : (this.isEditEnvironmentUsernameEmpty = false);
  }

  onEditEnvironmentControlRoom(e: any) {
    e.target.value.substring(0, 1) === " "
      ? ((e.target.value = ""),
        (this.ed_environmentControlRoom = ""),
        (this.isEditEnvControlRoomEmpty = true))
      : (this.isEditEnvControlRoomEmpty = false);
  }

  onEditEnvironmentName(e: any) {
    e.target.value.substring(0, 1) === " "
      ? ((e.target.value = ""),
        (this.ed_environmentName = ""),
        (this.isEditEnvironmentNameEmpty = true))
      : (this.isEditEnvironmentNameEmpty = false);
  }

  onEditEnvironmentAPIKey(e: any) {
    e.target.value.substring(0, 1) === " "
      ? ((e.target.value = ""),
        (this.ed_EnvironmentAPIKey = ""),
        (this.isEditEnvironmentAPIKeyEmpty = true))
      : (this.isEditEnvironmentAPIKeyEmpty = false);
  }

  onEditEnvironmentPassword(e: any) {
    e.target.value.substring(0, 1) === " "
      ? ((e.target.value = ""),
        (this.ed_EnvironmentPassword = ""),
        (this.isEditEnvironmentPasswordEmpty = true))
      : (this.isEditEnvironmentPasswordEmpty = false);
  }

  onEnvironmentUsername(e: any) {
    e.target.value.substring(0, 1) === " "
      ? ((e.target.value = ""),
        (this.addEnvironmentUsername = ""),
        (this.isEnvironmentUsernameEmpty = true))
      : (this.isEnvironmentUsernameEmpty = false);
  }

  onEnvironmentAPIKey(e: any) {
    e.target.value.substring(0, 1) === " "
      ? ((e.target.value = ""),
        (this.environmentAPIKey = ""),
        (this.isEnvironmentAPIKeyEmpty = true))
      : (this.isEnvironmentAPIKeyEmpty = false);
  }

  onEnvironmentPassword(e: any) {
    e.target.value.substring(0, 1) === " "
      ? ((e.target.value = ""),
        (this.addEnvironmentPassword = ""),
        (this.isEnvironmentPasswordEmpty = true))
      : (this.isEnvironmentPasswordEmpty = false);
  }

  editEnvironmentList() {
    this.ed_environmentName === ""
      ? (this.isEditEnvironmentNameEmpty = true)
      : (this.isEditEnvironmentNameEmpty = false);

    this.ed_environmentControlRoom === ""
      ? (this.isEditEnvControlRoomEmpty = true)
      : (this.isEditEnvControlRoomEmpty = false);

    this.ed_environmentUsername === ""
      ? (this.isEditEnvironmentUsernameEmpty = true)
      : (this.isEditEnvironmentUsernameEmpty = false);

    this.ed_EnvironmentAPIKey === ""
      ? (this.isEditEnvironmentAPIKeyEmpty = true)
      : (this.isEditEnvironmentAPIKeyEmpty = false);

    this.ed_EnvironmentPassword === ""
      ? (this.isEditEnvironmentPasswordEmpty = true)
      : (this.isEditEnvironmentPasswordEmpty = false);

    let AAType = this.isAPIKeySelected === true ? 0 : 1;
    let key = this.ed_EnvironmentAPIKey;

    console.log('Update');

    if (this.isAPIKeySelected) {
      if (
        this.ed_environmentName !== "" &&
        this.ed_environmentControlRoom !== "" &&
        this.ed_EnvironmentAPIKey !== "" &&
        this.ed_environmentUsername !== ""
      ) {
        this.isLoading = true;
        this._restService
          .updateEnvironment(
            this.environmentId,
            this.ed_environmentName,
            this.ed_environmentControlRoom,
            this.ed_environmentUsername,
            key,
            this.ed_EnvironmentPassword,
            AAType,
            this.masterEnvironmentId
          )
          .pipe(
            catchError((e) => {
              console.log("err --->", e);
              this.isLoading = false;
              this.isFailure = true;
              this.failureMessage = e.error.StatusInfo;
              return e;
            })
          )
          .subscribe(
            (f: any) => (
              (this.isLoading = false),
              (this.isSuccess = true),
              (this.successMessage = f.StatusInfo),
              this._restService
                .environmentMasterList()
                .pipe(
                  catchError((e) => {
                    (this.isFailure = true),
                      (this.failureMessage = e.error.StatusInfo);
                    console.log("Onload Error --->", e.error);
                    return e;
                  })
                )
                .subscribe((f: any) => (this.environmentList = f.EnvList)),
              (this.isEditEnvironmentShown = false)
            )
          );
      }
    } else {
      let AAType = this.isAPIKeySelected === true ? 0 : 1;
      let key = this.ed_EnvironmentAPIKey;

      if (
        this.ed_environmentName !== "" &&
        this.ed_environmentControlRoom !== "" &&
        this.ed_EnvironmentPassword !== "" &&
        this.ed_environmentUsername !== ""
      ) {
        this.isLoading = true;
        this._restService
          .updateEnvironment(
            this.environmentId,
            this.ed_environmentName,
            this.ed_environmentControlRoom,
            this.ed_environmentUsername,
            key,
            this.ed_EnvironmentPassword,
            AAType,
            this.masterEnvironmentId
          )
          .pipe(
            catchError((e) => {
              console.log("err --->", e);
              this.isLoading = false;
              this.isFailure = true;
              this.failureMessage = e.error.StatusInfo;
              return e;
            })
          )
          .subscribe(
            (f: any) => (
              (this.isLoading = false),
              (this.isSuccess = true),
              (this.successMessage = f.StatusInfo),
              this._restService
                .environmentMasterList()
                .pipe(
                  catchError((e) => {
                    (this.isFailure = true),
                      (this.failureMessage = e.error.StatusInfo);
                    console.log("Onload Error --->", e.error);
                    return e;
                  })
                )
                .subscribe((f: any) => (this.environmentList = f.EnvList)),
              (this.isEditEnvironmentShown = false)
            )
          );
      }
    }
  }

  cancelEditEnvironment() {
    this.isEditEnvironmentShown = false;
    this.isEnvironmentNameEmpty = false;
    this.isControlRoomEmpty = false;
    this.isEnvironmentAPIKeyEmpty = false;
  }

  deleteEnvironment(eid: any, meid: any, type: string) {
    this.isLoading = true;
    console.log(eid);
    console.log(meid);
    console.log(type);

    this._restService
      .removeEnvironment(eid, meid, type)
      .pipe(
        catchError((e) => {
          console.log("err --->", e);
          this.isLoading = false;
          this.isFailure = true;
          this.failureMessage = e.error.StatusInfo;
          return e;
        })
      )
      .subscribe(
        (f: any) => (
          (this.isLoading = false),
          (this.isSuccess = true),
          (this.successMessage = f.StatusInfo),
          this._restService
            .environmentMasterList()
            .pipe(
              catchError((e) => {
                (this.isFailure = true),
                  (this.failureMessage = e.error.StatusInfo);
                console.log("Onload Error --->", e.error);
                return e;
              })
            )
            .subscribe((f: any) => (this.environmentList = f.EnvList))
        )
      );
  }

  addEnvironmentList() {
    console.log(
      this.addEnvironmentName +
        "----" +
        this.addEnvironmentControlRoom +
        "----" +
        this.addEnvironmentAPIKey
    );

    this.addEnvironmentName === ""
      ? (this.isEnvironmentNameEmpty = true)
      : (this.isEnvironmentNameEmpty = false);
    this.addEnvironmentControlRoom === ""
      ? (this.isControlRoomEmpty = true)
      : (this.isControlRoomEmpty = false);
    this.addEnvironmentAPIKey === ""
      ? (this.isEnvironmentAPIKeyEmpty = true)
      : (this.isEnvironmentAPIKeyEmpty = false);
    this.addEnvironmentUsername === ""
      ? (this.isEnvironmentUsernameEmpty = true)
      : (this.isEnvironmentUsernameEmpty = false);
    this.addEnvironmentPassword === ""
      ? (this.isEnvironmentPasswordEmpty = true)
      : (this.isEnvironmentPasswordEmpty = false);

    let AAType = this.isAPIKeySelected === true ? 0 : 1;
    let key = this.addEnvironmentAPIKey.replace(/\\/, "");

    if (this.isAPIKeySelected) {
      if (
        this.addEnvironmentName !== "" &&
        this.addEnvironmentControlRoom !== "" &&
        this.addEnvironmentUsername !== "" &&
        this.addEnvironmentAPIKey !== ""
      ) {
        this.isAddEnvironmentShown = false;
        this.isLoading = true;
        this._restService
          .addEnvironment(
            this.addEnvironmentName,
            this.addEnvironmentControlRoom,
            this.addEnvironmentUsername,
            key,
            this.addEnvironmentPassword,
            AAType
          )
          .pipe(
            catchError((e) => {
              console.log("err --->", e);
              this.isLoading = false;
              this.isFailure = true;
              this.failureMessage = e.error.StatusInfo;
              return e;
            })
          )
          .subscribe(
            (f: any) => (
              (this.isLoading = false),
              (this.isSuccess = true),
              (this.successMessage = f.StatusInfo),
              (this.addEnvironmentName = ""),
              (this.addEnvironmentControlRoom = ""),
              (this.addEnvironmentAPIKey = ""),
              (this.addEnvironmentUsername = ""),
              (this.addEnvironmentPassword = ""),
              this._restService
                .environmentMasterList()
                .pipe(
                  catchError((e) => {
                    (this.isFailure = true),
                      (this.failureMessage = e.error.StatusInfo);
                    console.log("Onload Error --->", e.error);
                    return e;
                  })
                )
                .subscribe((f: any) => (this.environmentList = f.EnvList))
            )
          );
      }
    } else {
      let AAType = this.isAPIKeySelected === true ? 0 : 1;
      let key = this.addEnvironmentAPIKey.replace(/\\/, "");

      if (
        this.addEnvironmentName !== "" &&
        this.addEnvironmentControlRoom !== "" &&
        this.addEnvironmentUsername !== "" &&
        this.addEnvironmentPassword !== ""
      ) {
        this.isAddEnvironmentShown = false;
        this.isLoading = true;
        this._restService
          .addEnvironment(
            this.addEnvironmentName,
            this.addEnvironmentControlRoom,
            this.addEnvironmentUsername,
            key,
            this.addEnvironmentPassword,
            AAType
          )
          .pipe(
            catchError((e) => {
              console.log("err --->", e);
              this.isLoading = false;
              this.isFailure = true;
              this.failureMessage = e.error.StatusInfo;
              return e;
            })
          )
          .subscribe(
            (f: any) => (
              (this.isLoading = false),
              (this.isSuccess = true),
              (this.successMessage = f.StatusInfo),
              (this.addEnvironmentName = ""),
              (this.addEnvironmentControlRoom = ""),
              (this.addEnvironmentAPIKey = ""),
              (this.addEnvironmentUsername = ""),
              (this.addEnvironmentPassword = ""),
              this._restService
                .environmentMasterList()
                .pipe(
                  catchError((e) => {
                    (this.isFailure = true),
                      (this.failureMessage = e.error.StatusInfo);
                    console.log("Onload Error --->", e.error);
                    return e;
                  })
                )
                .subscribe((f: any) => (this.environmentList = f.EnvList))
            )
          );
      }
    }
  }

  canceladdEnvironment() {
    this.isEditEnvironmentShown = false;
    this.isEnvironmentNameEmpty = false;
    this.isControlRoomEmpty = false;
    this.isAddEnvironmentShown = false;
  }

  uiPathTestEvent(){
    if (!this.validateUIPathValues()){
      return;
    }

    this.isLoading = true;

    this._restService.testUIPathConnection(this.addAccountId, this.addAccountSecret)
      .pipe(
        catchError((e) => {
          console.log("err --->", e);
          this.isLoading = false;
          this.isFailure = true;
          this.failureMessage = e.error.StatusInfo;
          return e;
        })
      )
      .subscribe(
        (f: any) => {
          this.isSuccess = true;
          this.successMessage = f.StatusInfo;
          this.isLoading = false;
      });
  }

  addUIPathEnvironmentList(){
    if (!this.validateUIPathValues()){
      return false;
    }

    this.isLoading = true;

    this._restService.addUIPathEnvironment(
      this.addEnvironmentName,
      this.environmentType,
      this.addOrganisationName,
      this.addTenantName,
      `https://cloud.uipath.com`,
      this.addAccountId, 
      this.addAccountSecret
      )
      .pipe(
        catchError((e) => {
          console.log("err --->", e);
          this.isLoading = false;
          this.isFailure = true;
          this.failureMessage = e.error.StatusInfo;
          return e;
        })
      )
      .subscribe(
        (f: any) => {
          this.isSuccess = true;
          this.successMessage = f.StatusInfo;
          
          this._restService
              .environmentMasterList()
              .pipe(
                catchError((e) => {
                  (this.isFailure = true);
                  this.isLoading = false;
                    (this.failureMessage = e.error.StatusInfo);
                  console.log("Onload Error --->", e.error);
                  return e;
                })
              )
              .subscribe((f: any) => {
                this.isLoading = false;
                this.environmentList = f.EnvList
              })
      });

  }

  validateUIPathValues() {
    const envName = this.isAddEnvironmentShown ? this.addEnvironmentName : this.ed_environmentName;
    
    if (!this.addAccountId || !this.addAccountSecret || !envName ||
      !this.addOrganisationName || !this.addTenantName) {
      this.showValidationErrors = true;
      return false;
    }

    return true;
  }

  editUIPathEnvironmentList() {
    if (!this.validateUIPathValues()){
      return false;
    }

    this.isLoading = true;

    this._restService.editUIPathEnvironment(
      this.environmentId,
      this.masterEnvironmentId,
      this.ed_environmentName,
      this.environmentType,
      this.addOrganisationName,
      this.addTenantName,
      `https://cloud.uipath.com`,
      this.addAccountId, 
      this.addAccountSecret
      )
      .pipe(
        catchError((e) => {
          console.log("err --->", e);
          this.isLoading = false;
          this.isFailure = true;
          this.failureMessage = e.error.StatusInfo;
          return e;
        })
      )
      .subscribe(
        (f: any) => {
        this.isSuccess = true;
        this.successMessage = f.StatusInfo;
        
        this._restService
            .environmentMasterList()
            .pipe(
              catchError((e) => {
                (this.isFailure = true);
                this.isLoading = false;
                  (this.failureMessage = e.error.StatusInfo);
                console.log("Onload Error --->", e.error);
                return e;
              })
            )
            .subscribe((f: any) => {
              this.isLoading = false;
              this.environmentList = f.EnvList
            })
      });
  }

  testconnection() {
    // alert("Working...");
  }
}
